import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { RouteUtil } from 'src/app/general/util/route-util';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStatus } from '../../util/util';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { Util } from 'src/app/general/util/util';
import { NavigationService } from '../../services/navigation.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocationEventsComponent } from '../../components/location-events/location-events.component';

@Component({
  selector: 'app-location-events-page',
  standalone: true,
  imports: [
    CommonModule,
    LocationEventsComponent,
    PageComponent,
    LocationHeaderComponent,
    ActionComponent,
    TranslateModule
  ],
  templateUrl: './location-events-page.component.html',
  styleUrls: ['./location-events-page.component.css']
})
export class LocationEventsPageComponent implements OnInit {

  locationId: string;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute,
      private navigationService: NavigationService) {
    this.locationId = '';
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.locationId = Util.safeString(pathParams.get('locationId'));
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }
}
